import { useEffect, useState } from 'react';
import LibModal from '../../../features/LibModal/LibModal';
import { useTemplate } from '../../../features/template/TemplateProvider';
import PageTitle from '../../../utils/PageTitle';
import BasicInformation from './Components/BasicInformation';
import InvoiceAuthorizationSetup from './Components/InvoiceAuthorizationSetup';
import InvoiceNote from './Components/InvoiceNote';
import InvoicePaymentConfig from './Components/InvoicePaymentConfig';
import { ApiLoadInvoiceInfo } from './InvoiceConfigOperation';
import ModalPaymentInfo from './Modals/ModalPaymentInfo';
import ModalUpdateAuthorization from './Modals/ModalUpdateAuthorization';
import UpdateInformationModal from './Modals/UpdateInformationModal';
import UpdateInvoiceNoteModal from './Modals/UpdateInvoiceNoteModal';

const initialState = {
    invConfig: {
        organization: '',
        phoneNumber: '',
        email: '',
        address: '',
        signatory1: '',
        signatory2: '',
        validity: 0
    },
    invNote: {
        noteTitle: '',
        noteDescription: ''
    }
};

function InvoiceConfigPage() {
    const [invConfigInfo, setInvConfigInfo] = useState(initialState);
    const [reloadKey, setReloadKey] = useState(0);
    // const [openModal, setOpenModal] = useState('');

    const { setMessage, modalType, closeModal, openModal, modalData } = useTemplate();

    // -- Load invoice list data
    useEffect(() => {
        setInvConfigInfo(initialState);
        ApiLoadInvoiceInfo()
            .then(({ data }) => {
                setInvConfigInfo(data);
            })
            .catch((err) => {
                setInvConfigInfo(initialState);
                setMessage({ type: 'error', text: err.toString(0) });
            });
    }, [setMessage, reloadKey]);

    const handleReload = () => {
        setReloadKey((d) => d + 1);
    };

    // set page title
    PageTitle(`Invoice Setting`);

    return (
        <div className="flex justify-center ">
            <div className=" inner_page_cont w-full max-w-[900px] p-4 md:p-[50px] !pb-40">
                <div className="w-full flex items-center justify-between  border-b border-primary-100 pb-4 mb-5">
                    <h1 className="text-3xl font-medium text-primary">Invoice Config</h1>
                    {/* <ButtonPrimary
                        title="Edit Information"
                        onClick={() => setOpenModal('edit_info')}
                    /> */}
                </div>

                <BasicInformation data={invConfigInfo?.invConfig} setOpenModal={openModal} />

                <hr className="my-3" />
                <InvoiceAuthorizationSetup
                    data={invConfigInfo?.invAuthConfig}
                    setOpenModal={openModal}
                />

                <hr className="my-3" />

                <InvoiceNote data={invConfigInfo?.invNote} setOpenModal={openModal} />
                <hr className="my-3" />

                <InvoicePaymentConfig
                    data={invConfigInfo?.invPaymentConfig}
                    setOpenModal={openModal}
                    handleReload={handleReload}
                />

                {modalType === 'update_info' && (
                    <LibModal title="Update Information" setOpen={closeModal}>
                        <UpdateInformationModal
                            data={invConfigInfo?.invConfig}
                            closeModal={closeModal}
                            handleReload={handleReload}
                        />
                    </LibModal>
                )}

                {modalType === 'update_note' && (
                    <LibModal title="Update Note" setOpen={closeModal}>
                        <UpdateInvoiceNoteModal
                            data={invConfigInfo?.invNote}
                            closeModal={closeModal}
                            handleReload={handleReload}
                        />
                    </LibModal>
                )}
                {modalType === 'update_authorization' && (
                    <LibModal
                        title="Update Authorization"
                        setOpen={closeModal}
                        className="max-w-[400px]"
                    >
                        <ModalUpdateAuthorization
                            data={invConfigInfo?.invAuthConfig}
                            closeModal={closeModal}
                            handleReload={handleReload}
                        />
                    </LibModal>
                )}
                {modalType === 'add_payment_info' && (
                    <LibModal
                        title={
                            modalData?.isEdit
                                ? 'Update Payment Information'
                                : 'Add Payment Information'
                        }
                        setOpen={closeModal}
                        className="max-w-[400px]"
                    >
                        <ModalPaymentInfo
                            data={invConfigInfo?.invPaymentConfig}
                            closeModal={closeModal}
                            handleReload={handleReload}
                        />
                    </LibModal>
                )}
            </div>
        </div>
    );
}

export default InvoiceConfigPage;
